// extracted by mini-css-extract-plugin
module.exports = {"root":"product-truefit_root__Ck9wX","truefitCTASkeleton":"product-truefit_truefitCTASkeleton__btuuE","fitContent":"product-truefit_fitContent__68Vfp"};